module.exports = __webpack_public_path__ + "assets/f10d8dce2c1da8015fdd8dfbe73115ef.png";